import { render, staticRenderFns } from "./TwoFactorAuthenticationPopup.vue?vue&type=template&id=7064b33e&scoped=true&"
import script from "./TwoFactorAuthenticationPopup.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthenticationPopup.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuthenticationPopup.vue?vue&type=style&index=0&id=7064b33e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064b33e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VIcon,VTextField})
